export default {
  "pl": {
    "dashboard": {
      "greetings": "Cześć {first_name}",
      "titles": {
        "activityFeed": "Nowe aktywności",
        "assignedTasks": "Moje zadania dla",
        "newsFeed": "Aktualności",
        "ongoingTickets": "W toku",
        "openTickets": "Otwarte",
        "tickets": "Rozmowy",
        "totalTickets": "Wszystkie",
        "unreadTickets": "Nieprzeczytane",
        "yourAssignedTickets": "Rozmowy przypisane do ciebie"
      }
    }
  }
}
